module.exports = __webpack_public_path__ + "img/GM.c03bbe03.svg";